import React from 'react';

import { Stack, Grid, Button } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';

import { FIELD_UM_ID, FIELD_APPLICATION_ID } from './constants';
import { validationSchema } from './schema';
import { loadApplications } from './source/filters';

const LastActivityForm = withForm({
  validationSchema: validationSchema,
})(({ submitForm, isLoading }) => {
  return (
    <Stack direction={'column'} spacing={4}>
      <FormField.Select
        label={'Application'}
        name={FIELD_APPLICATION_ID}
        source={loadApplications}
        required={true}
        padding={0}
      />
      <FormField.TextField
        label={'UM ID'}
        name={FIELD_UM_ID}
        placeholder={'XXXXXXXXXX'}
        padding={0}
      />
      <Grid container justifyContent={'flex-end'}>
        <Grid item>
          <Button
            variant={'contained'}
            role={'button'}
            onClick={submitForm}
            disabled={isLoading}
          >
            Apply
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
});

export default LastActivityForm;
